import { useQuery } from "react-query";
import { getProfileFn } from "../Services/Profile";

export const useProfile = () => {
  return useQuery(["profile"], () => getProfileFn());
};
